import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import { fetchSODPTickets, setFilters, clearFilters, clearError } from '../store/sodpSlice';

export const useSODPTickets = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { tickets, loading, error, lastFetched, filters } = useSelector(
    (state: RootState) => state.sodp
  );

  // Fetch tickets on mount
  useEffect(() => {
    dispatch(fetchSODPTickets());
  }, [dispatch]);

  // Filter tickets based on current filters
  const filteredTickets = tickets.filter((ticket) => {
    const statusMatch = filters.status.length === 0 || filters.status.includes(ticket.status);
    const priorityMatch = filters.priority.length === 0 || filters.priority.includes(ticket.priority);
    const assigneeMatch = filters.assignee.length === 0 || 
      (ticket.assignee && filters.assignee.includes(ticket.assignee));

    return statusMatch && priorityMatch && assigneeMatch;
  });

  // Get unique values for filter options
  const filterOptions = {
    status: [...new Set(tickets.map(ticket => ticket.status))],
    priority: [...new Set(tickets.map(ticket => ticket.priority))],
    assignee: [...new Set(tickets.map(ticket => ticket.assignee).filter(Boolean))],
  };

  const refreshTickets = () => {
    dispatch(fetchSODPTickets());
  };

  const updateFilters = (newFilters: Partial<typeof filters>) => {
    dispatch(setFilters(newFilters));
  };

  const resetFilters = () => {
    dispatch(clearFilters());
  };

  const dismissError = () => {
    dispatch(clearError());
  };

  return {
    tickets: filteredTickets,
    allTickets: tickets,
    loading,
    error,
    lastFetched,
    filters,
    filterOptions,
    refreshTickets,
    updateFilters,
    resetFilters,
    dismissError,
  };
};
